import React, { StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import App from './App';

const ssrState = (window as any)?._ssrState;

hydrateRoot(
	document.getElementById('app')!,
	<StrictMode>
		<App data={ssrState} />
	</StrictMode>
);
